





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import Popup from '@/components/default/Popup.vue';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';
import CreateSettlementPopup from '@/modules/projects/measuringStates/components/CreateSettlementPopup.vue';
import ProjectDesignOrderPopup from '@/modules/projects/components/orders/ProjectDesignOrderPopup.vue';

import {
  MeasuringStatesClient,
  MeasuringStateListItemDto,
  ContactsClient,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  ContractsClient,
  CreateContractFromMeasuringStateCommand,
  MergeMeasuringStateCommand,
  InvoicesClient,
  GenerateInvoiceFromMeasuringStatesCommand,
  TunnelGroup,
  TunnelGroupsClient,
  MeasuringState,
  Project,
  ISecurityConfig,
} from '@/data/web-api-client';
import AuthenticationService from '@/auth/AuthenticationService';
import { SecurityConfig } from '@/installationConfig';

@Component({
  components: {
    Card,
    Datagrid,
    Popup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    CreateSettlementPopup,
    ProjectDesignOrderPopup,
  },
})
export default class MeasuringStatesTable extends Vue {
  @Prop({ required: true })
  project!: Project;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  generateContractCommand = new CreateContractFromMeasuringStateCommand({
    projectId: '',
    measuringStateRef: '',
    subcontractorId: '',
    tunnelGroupsId: '',
  });
  items: MeasuringStateListItemDto[] = [];
  showContractDialog: boolean = false;
  generating: boolean = false;
  loading: boolean = true;

  selectedNumbers: string[] = [];
  tunnelGroups: TunnelGroup[] = [];
  measuringStatesClient = new MeasuringStatesClient(undefined, this.$axios);
  securityConfig: ISecurityConfig = SecurityConfig;

  private authService = new AuthenticationService();

  public async created() {
    this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();
    this.loadData();
  }

  public async loadData() {
    try {
      this.loading = true;
      this.items = await this.measuringStatesClient.get(this.project.id!);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  // type is object, no devextreme type yet for this version
  // https://js.devexpress.com/Vue/Documentation/20_2/ApiReference/UI_Components/dxDataGrid/Configuration/columns/buttons/#onClick
  public showGenerateContractDialog(clickEvent: any) {
    this.generateContractCommand.projectId = this.project.id;
    this.generateContractCommand.measuringStateRef = clickEvent.row.data.documentNumber;

    const measuringState: MeasuringStateListItemDto = this.items.find((item) => item.documentNumber === clickEvent.row.data.documentNumber)!;

    this.generateContractCommand.subcontractorId = measuringState!.subcontractorId!;
    this.generateContractCommand.tunnelGroupsId = measuringState?.tunnelGroupsId;

    const noTunnelGroup = this.generateContractCommand.tunnelGroupsId == null || this.generateContractCommand.tunnelGroupsId == undefined;

    const contractType = noTunnelGroup ? this.contractTypes.find((x: string) => x.includes('arbeid')) : this.contractTypes.find((x: string) => x.includes('Beide'));

    this.generateContractCommand = new CreateContractFromMeasuringStateCommand({
      projectId: this.project.id,
      measuringStateRef: clickEvent.row.data.documentNumber,
      subcontractorId: measuringState!.subcontractorId!,
      tunnelGroupsId: measuringState?.tunnelGroupsId,
      contractType: contractType,
    });

    this.showContractDialog = true;
  }

  public openDetails(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && this.project && e.column.type !== 'selection') {
      this.$router.push({
        path: `/measuringstates/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}`,
      });
    }
  }

  public async generateContract() {
    try {
      const validationResult = (this.$refs.generateContractForm as any).instance.validate();
      if (validationResult.isValid && this.project) {
        this.generating = true;

        const result = await new ContractsClient(undefined, this.$axios).create(this.generateContractCommand);
        notificationService.saved();
        this.$router.push({
          path: `/contracts/${result.replace('/', '-').replace('/', '-')}`,
        });
        this.$emit('saved');
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.generating = false;
    }
  }

  public deleteMeasurementstate(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        if (e && e.data && e.data.documentNumber) {
          const documentnumber: string = (e.data.documentNumber as string).replaceAll('/', '-');
          await this.measuringStatesClient.remove(documentnumber);

          notificationService.saved();
        }

        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
        reject(false);
      }
    });
  }

  closeContractDialog() {
    this.showContractDialog = false;
    this.generateContractCommand = new CreateContractFromMeasuringStateCommand({
      projectId: '',
      measuringStateRef: '',
      subcontractorId: '',
      tunnelGroupsId: '',
    });
  }

  async merge() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IMeasurement[] = (grid.$refs.measuringStatesTable as any).instance.getSelectedRowsData();
      const nameList = selectedRows.map((o) => o.documentNumber);
      try {
        await this.measuringStatesClient.merge(
          new MergeMeasuringStateCommand({
            documentNumbers: nameList,
            projectId: this.project.id,
          })
        );

        this.loadData();
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  async createInvoice() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IMeasurement[] = (grid.$refs.measuringStatesTable as any).instance.getSelectedRowsData();
      const nameList = selectedRows.map((o) => o.documentNumber);
      this.selectedNumbers = nameList;
      try {
        var result = await new InvoicesClient(undefined, this.$axios).generateFromMeasuringState(
          new GenerateInvoiceFromMeasuringStatesCommand({
            projectId: this.project.id,
            measuringStateNumbers: this.selectedNumbers,
          })
        );

        notificationService.saved();
        this.$router.push({ path: `/invoices/${result}` });
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  createSettlement() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IMeasurement[] = (grid.$refs.measuringStatesTable as any).instance.getSelectedRowsData();
      const nameList = selectedRows.map((o) => o.documentNumber);
      try {
        (this.$refs.CreateSettlementPopup as CreateSettlementPopup).open({
          selectedMeasuringStates: nameList,
          projectId: this.project ? this.project.id! : '',
          contractNumber: '',
        });
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  createOrder() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IMeasurement[] = (grid.$refs.measuringStatesTable as any).instance.getSelectedRowsData();
      const nameList = selectedRows.map((o) => o.documentNumber);
      this.selectedNumbers = nameList;
      try {
        (this.$refs.ProjectDesignOrderPopup as ProjectDesignOrderPopup).open();
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  ordersCreated() {
    this.$emit('ordersCreated');
  }

  isNotInRole(roles: string[]): boolean {
    return this.authService.isNotInRole(roles);
  }

  get isAbleToCreateQuote() {
    if (!this.securityConfig || !this.securityConfig.administratorGroup) {
      return;
    }

    return this.authService.hasRole(this.securityConfig.administratorGroup) || this.authService.isNotInRole([this.securityConfig.qualityGuardOneSkinGroup || '']);
  }

  get GridInstance() {
    return ((this.$refs.grid as Vue).$refs.measuringStatesTable as any).instance;
  }

  get columns() {
    const self = this;

    return [
      {
        dataField: 'documentNumber',
        caption: 'Documentnr.',
      },
      {
        dataField: 'createDate',
        caption: 'Aanmaakdatum',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'title',
        caption: 'Titel',
      },
      {
        dataField: 'executedPercentage',
        caption: 'Uitgevoerd %',
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'subcontractorId',
        caption: 'Onderaannemer',
        lookup: {
          dataSource: {
            store: this.subcontractorStore,
            paginate: true,
          },
          displayExpr: 'displayName',
          valueExpr: 'id',
          paginate: true,
        },
      },
      {
        dataField: 'measurementType',
        caption: 'Opmetingstype',
        lookup: {
          dataSource: {
            store: this.measurementTypes,
            paginate: true,
          },
          paginate: true,
        },
      },
      {
        dataField: 'measuringStateType',
        caption: 'Type',
        lookup: {
          dataSource: {
            store: this.measuringStateTypes,
            paginate: true,
          },
          paginate: true,
        },
        calculateCellValue(value: MeasuringState) {
          if (value.measuringStateType == '' || value.measuringStateType == null) {
            return 'Klad';
          }

          return value.measuringStateType;
        },
      },
      {
        dataField: 'contractDocumentNumbers',
        caption: this.$t('objects.measuringStates.fields.ContractDocumentNumbers'),
        // A measuring state can be linked to 0, 1 or several contracts (n:1, Contract.MeasuringStateRef),
        // so this is a comma-separated list computed server-side, not a single sortable/filterable value.
        calculateCellValue(value: MeasuringStateListItemDto) {
          return (value.contractDocumentNumbers ?? []).join(', ');
        },
        allowFiltering: false,
        allowSorting: false,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Gefactureerd',
            icon: 'fas fa-euro-sign',
            visible(e: any) {
              return e.row.data.allLinesInvoiced == true;
            },
          },
          {
            hint: 'Afgerekend aan onderaannemer',
            icon: 'fas fa-hard-hat',
            visible(e: any) {
              return e.row.data.allLinesInvoicedSubcontractor == true;
            },
          },
          {
            hint: 'Contract maken',
            icon: 'fas fa-file-contract',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
            },
            onClick: this.showGenerateContractDialog,
          },
          'edit',
          'delete',
        ],
      },
    ];
  }

  get subcontractorStore() {
    const client = new ContactsClient(undefined, this.$axios);

    return new dxCustomStore({
      key: 'id',
      load: async (loadOptions: any) => {
        if (loadOptions.filter) {
          loadOptions.filter = undefined;
        }
        if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
          loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
        }

        const res = await client.lookupContacts(
          new ContactsLookupQuery({
            tunnelGroupsId: this.generateContractCommand.tunnelGroupsId,
            type: 'Subcontractor',
            options: new DataSourceLoadOptionsBase(
              Object.assign({}, loadOptions, {
                stringToLower: true,
              })
            ),
          })
        );

        return res;
      },
      byKey: async (val: string) => {
        return await client.getBasicInfo(val);
      },
    });
  }

  get subcontractorOptions() {
    return {
      dataSource: new DataSource({
        store: this.subcontractorStore,
        paginate: true,
      }),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get projecttypes() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');
    return catalog ? catalog.values : [];
  }

  get worktypes() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes');
    return catalog ? catalog.values : [];
  }

  get measurementTypes() {
    const catalog = this.$store.getters['catalogs/list']('MeasurementTypes');
    return catalog ? catalog.values : [];
  }

  get measuringStateTypes() {
    const catalog = this.$store.getters['catalogs/list']('MeasuringStateTypes');
    return catalog ? catalog.values : [];
  }

  get contractTypes() {
    const catalog = this.$store.getters['catalogs/list']('ContractTypes');
    return catalog ? catalog.values : [];
  }

  get contractOptions() {
    const noTunnelGroup = this.generateContractCommand.tunnelGroupsId == null || this.generateContractCommand.tunnelGroupsId == undefined;

    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions) => {
            if (noTunnelGroup) {
              return this.contractTypes.filter((x: string) => x.includes('arbeid'));
            }
            return this.contractTypes;
          },
          byKey: (val: any) => val,
        }),
      }),
      value: noTunnelGroup ? this.contractTypes.find((x: string) => x.includes('arbeid')) : this.contractTypes.find((x: string) => x.includes('Beide')),
      searchEnabled: true,
      disabled: this.generateContractCommand.tunnelGroupsId == null || this.generateContractCommand.tunnelGroupsId == undefined,
    };
  }

  get tunnelGroupsOptions() {
    const result = this.tunnelGroups.map((dg) => ({
      text: dg.name,
      value: dg.id,
    }));

    return {
      dataSource: result,
      displayExpr: 'text',
      valueExpr: 'value',
      onValueChanged: async () => {
        await this.subcontractorStore.load();
      },
      showClearButton: true,
      disabled: this.generateContractCommand.tunnelGroupsId == null || this.generateContractCommand.tunnelGroupsId == undefined,
    };
  }
}
